<template>
<!--    <div :class="{'has-logo':showLogo}" :style="{ backgroundColor: settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }">-->
    <div :class="{'has-logo':showLogo}" class="new-bg" style="background-color: #FFFFFF;">
        <logo v-if="showLogo" :collapse="isCollapse" />
        <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">

          <!--                :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground"-->
<!--          :text-color="settings.sideTheme === 'theme-dark' ? variables.menuColor : variables.menuLightColor"-->
<!--          background-color="#fff"-->
            <el-menu
                ref="sidebarMenu"
                :default-active="activeMenu"
                :collapse="isCollapse"
                class="el-menu-vertical-demo"

                :text-color="settings.sideTheme === 'theme-dark' ? 'var(--theme-sidebar-text)' : 'var(--theme-primary)'"
                :active-text-color="'var(--theme-primary)'"
                :unique-opened="true"

                :collapse-transition="false"
                mode="vertical"
            >
                <sidebar-item
                    v-for="(route, index) in sidebarRouters"
                    :key="route.path  + index"
                    :item="route"
                    :base-path="route.path"
                />
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import Logo from "./Logo"
import SidebarItem from "./SidebarItem"
import variables from "@/assets/styles/variables.scss"

export default {
    components: { SidebarItem, Logo },
    computed: {
        ...mapState(["settings"]),
        ...mapGetters(["sidebarRouters", "sidebar"]),
        activeMenu() {
            const route = this.$route
            const { meta, path } = route
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu
            }
            return path
        },
        showLogo() {
            return this.$store.state.settings.sidebarLogo
        },
        variables() {
            return variables
        },
        isCollapse() {
            return !this.sidebar.opened
        }
    },
    watch: {
        "$route.path": {
            handler(path) {
                if (path !== "/index") {
                    return
                }
                this.$nextTick(() => {
                    this.closeOpenedMenus()
                })
            },
            immediate: true
        }
    },
    mounted() {
        document.addEventListener("click", this.handleDocumentClick)
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleDocumentClick)
    },
    methods: {
        handleDocumentClick(event) {
            if (!this.isCollapse || this.$el.contains(event.target)) {
                return
            }
            const popper = event.target.closest && event.target.closest(".el-menu--vertical")
            if (!popper) {
                this.closeOpenedMenus()
            }
        },
        closeOpenedMenus() {
            const menu = this.$refs.sidebarMenu
            if (!menu) {
                return
            }
            menu.openedMenus.slice().forEach(index => menu.close(index))
        }
    }
}
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo {
  border-right: none;
  font-weight: bold;
}
.new-bg {
    background-color: #FFFFFF;
  //backgroundColor: #f0f2f5;
}
</style>
